export const DIGEST_API_QUERY_LENGTH_THRESHOLD = 6000;

const DIGEST_API_OVERLAY_KEYS = new Set([
  'limit',
  'offset',
  'sort',
  'select',
  'search',
  'filtersCount',
  'plotPeriod',
  'plotValues',
  'subtotalBy',
  'groupBy',
  'groupSums',
  'criteria',
  'by',
  'sortableColumn'
]);

const isRegistryInternalKey = (key: string): boolean => key.startsWith('__registry');

export interface DigestApiPayload {
  filters: Record<string, unknown>;
  select?: unknown;
}

export const stripDigestApiInternalKeys = (queryParams: Record<string, unknown>): Record<string, unknown> => Object
  .fromEntries(Object
    .entries(queryParams)
    .filter(([key]) => !isRegistryInternalKey(key))
  );

/** Checks the final URL-encoded query length, not the source object size. */
export const shouldUseDigestForApiQuery = (serializedQuery: string): boolean =>
  serializedQuery.length > DIGEST_API_QUERY_LENGTH_THRESHOLD;

export const pickDigestApiOverlayParams = (
  queryParams: Record<string, unknown>
): Record<string, unknown> => Object.fromEntries(
  Object.entries(queryParams).filter(([key]) => DIGEST_API_OVERLAY_KEYS.has(key))
);

export const buildDigestApiPayload = (queryParams: Record<string, unknown>): DigestApiPayload => {
  const filters = Object.fromEntries(Object.entries(queryParams).filter(([key]) => !DIGEST_API_OVERLAY_KEYS.has(key)));
  const select = queryParams.select;

  return {
    filters,
    ...(select === undefined ? {} : { select })
  };
};
